import { OnInit, EventEmitter, OnDestroy } from '@angular/core';
import { AssessmentGroupService } from '../services/assessment-group.service';
import { AssessmentGroupDisplay } from '../../shared/models/assessment-group-display';
import { AssessmentTokenService } from '../../shared/services/assessment-token.service';
import { AuthService } from 'app/login/services/auth.service';
import { Capability } from 'app/shared/models/capability';
var AssessmentGroupListComponent = /** @class */ (function () {
    function AssessmentGroupListComponent(assessmentGroupService, assessmentTokenService, authService) {
        var _this = this;
        this.assessmentGroupService = assessmentGroupService;
        this.assessmentTokenService = assessmentTokenService;
        this.authService = authService;
        this.selected = new EventEmitter();
        this.buy = new EventEmitter();
        this.hasLoadedTokens = false;
        this.groups = [];
        this.canShop = false;
        this._userSubscription = this.authService.getLoginState().subscribe(function (loginState) {
            if (loginState.user) {
                _this.canShop = loginState.user.hasCapability(Capability.CAN_SHOP);
            }
            else {
                _this.canShop = false;
            }
        });
    }
    AssessmentGroupListComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.assessmentGroupService.getAssessmentGroups().then(function (groups) {
            // add a display property so we can expand/contract it.
            _this.groups = groups.map(function (g) {
                var displayGroup = new AssessmentGroupDisplay();
                Object.assign(displayGroup, g);
                displayGroup.Show = false;
                return displayGroup;
            });
            return groups;
        })
            .then(function (groups) {
            return _this.assessmentTokenService.loadAssessmentTokens().then(function () {
                _this.hasLoadedTokens = true;
            });
        });
    };
    AssessmentGroupListComponent.prototype.ngOnDestroy = function () {
        this._userSubscription.unsubscribe();
    };
    Object.defineProperty(AssessmentGroupListComponent.prototype, "tokensEnabled", {
        get: function () {
            return this.assessmentTokenService.isTokensEnabled();
        },
        enumerable: true,
        configurable: true
    });
    AssessmentGroupListComponent.prototype.getTokensRemaining = function (assessment) {
        if (!assessment) {
            return 0;
        }
        return this.assessmentTokenService.getRemainingTokens(assessment);
    };
    AssessmentGroupListComponent.prototype.getGroupTokensRemaining = function (group) {
        if (!group) {
            return 0;
        }
        return this.assessmentTokenService.getGroupRemainingTokens(group);
    };
    AssessmentGroupListComponent.prototype.shouldBuyTokens = function (group) {
        var tokens = this.getGroupTokensRemaining(group);
        return this.canShop && tokens <= 0;
    };
    AssessmentGroupListComponent.prototype.pickGroup = function (group) {
        this.selected.emit(group);
    };
    AssessmentGroupListComponent.prototype.toggleGroup = function (group, event) {
        group.Show = !group.Show;
        console.log(group, group.Show);
        event.preventDefault();
        event.stopPropagation();
    };
    AssessmentGroupListComponent.prototype.addAssessmentToGroup = function (group, assessment) {
        var dup = group.Assessments.find(function (a) { return a.uid == assessment.uid; });
        if (dup) {
            alert("This assessment already has been added.");
            return;
        }
        group.Assessments.push(assessment);
        this.assessmentGroupService.addAssessmentToGroup(group, assessment).then(function (assessment) {
            assessment.version = assessment.version;
            assessment.id = assessment.id;
        })
            .catch(function (error) {
            console.error(error);
            // TODO: stephen need to display an error here...
            // remove it
            var index = group.Assessments.indexOf(assessment);
            if (index >= 0) {
                group.Assessments.splice(index, 1);
            }
        });
    };
    AssessmentGroupListComponent.prototype.addGroup = function () {
        var _this = this;
        this.assessmentGroupService.createNewGroup(this.NewGroupName).then(function (group) {
            var display = new AssessmentGroupDisplay();
            Object.assign(display, group);
            // hide all the others, and show the one we just added.
            _this.groups.forEach(function (g) { return g.Show = false; });
            display.Show = true;
            display.ShowAdd = true;
            _this.NewGroupName = "";
            _this.groups.push(display);
        });
    };
    AssessmentGroupListComponent.prototype.triggerBuy = function (group) {
        this.buy.emit(group);
    };
    Object.defineProperty(AssessmentGroupListComponent.prototype, "Groups", {
        get: function () {
            return this.groups;
        },
        enumerable: true,
        configurable: true
    });
    return AssessmentGroupListComponent;
}());
export { AssessmentGroupListComponent };



// WEBPACK FOOTER //
// ./src/app/shared/assessment-group-list/assessment-group-list.component.ts.pre-build-optimizer.js